import React, { useRef } from "react"
import { Rerousel } from "rerousel"

import image1 from "images/brands/1.png"
import image2 from "images/brands/2.png"
import image3 from "images/brands/3.png"
import image4 from "images/brands/4.png"
import image5 from "images/brands/5.png"
import image6 from "images/brands/6.png"

import { Container, Item, Description, TopPlaceholder, BottomPlaceholder } from "./styles"

const HomePageBrandCarousel = () => {
  const ref = useRef(null)

  const brands = [
    {
      id: "brand-1",
      brand: "Town & Country",
      imageSrc: image1,
      // description: "“Lorem ipsum dolor sit amet”",
    },
    {
      id: "brand-2",
      brand: "Essence",
      imageSrc: image2,
      // description: "“Lorem ipsum dolor sit amet”",
    },
    {
      id: "brand-3",
      brand: "Forbes",
      imageSrc: image3,
      // description: "“Lorem ipsum dolor sit amet”",
    },
    {
      id: "brand-4",
      brand: "The New York Times",
      imageSrc: image4,
      // description: "“Lorem ipsum dolor sit amet”",
    },
    {
      id: "brand-5",
      brand: "The Cut",
      imageSrc: image5,
      // description: "“Lorem ipsum dolor sit amet”",
    },
    {
      id: "brand-6",
      brand: "GMA",
      imageSrc: image6,
      // description: "“Lorem ipsum dolor sit amet”",
    },
  ]

  return (
    <>
      <TopPlaceholder />
      <Container>
        <Rerousel itemRef={ref}>
          {brands.map(({ id, brand, description, imageSrc }) => (
            <Item key={id} ref={ref} itemCount={brands.length}>
              <img src={imageSrc} alt={brand} title={brand} />
              {description && <Description>{description}</Description>}
            </Item>
          ))}
        </Rerousel>
      </Container>
      <BottomPlaceholder />
    </>
  )
}

export default HomePageBrandCarousel
